import { tv, type VariantProps } from 'tailwind-variants'

import { cn } from '@/utils'

const variants = tv({
  base: 'inline-flex items-center rounded-full font-medium border',
  variants: {
    type: {
      default: 'text-slate-700 border-slate-200 bg-slate-50',
      'Credit card': 'text-amber-700 border-amber-200 bg-amber-50',
      Checking: 'text-blue-700 border-blue-200 bg-blue-50',
      Savings: 'text-purple-700 border-purple-200 bg-purple-50',
      'Debit card': 'text-emerald-700 border-emerald-200 bg-emerald-50',
      Loan: 'text-orange-700 border-orange-200 bg-orange-50',
      Investment: 'text-teal-700 border-teal-200 bg-teal-50',
      Retirement: 'text-indigo-700 border-indigo-200 bg-indigo-50',
      Other: 'text-slate-700 border-slate-200 bg-slate-50',
      // Segment kinds shown on the Files tab (Statement::Segment enum labels).
      Bank: 'text-blue-700 border-blue-200 bg-blue-50',
      Mixed: 'text-violet-700 border-violet-200 bg-violet-50',
      Checks: 'text-cyan-700 border-cyan-200 bg-cyan-50',
      Unclassified: 'text-slate-700 border-slate-200 bg-slate-50',
      // Set aside on purpose, so it reads as a quiet note and not a failure.
      'Not a bank statement': 'text-slate-600 border-slate-200 bg-slate-100',
    },
    size: {
      default: 'px-2 py-0.5 text-xs',
      xs: 'px-1.5 py-0.5 text-[10px]',
    },
  },
  defaultVariants: {
    type: 'default',
    size: 'default',
  },
})

export type AccountTypeBadgeVariant = VariantProps<typeof variants>['type']

interface AccountTypeBadgeProps extends VariantProps<typeof variants> {
  children?: React.ReactNode
}

export const AccountTypeBadge = ({
  type,
  size,
  children,
}: AccountTypeBadgeProps) => {
  return (
    <span className={cn(variants({ type, size }))}>{children ?? type}</span>
  )
}
